'use client'
import { useMemo } from 'react'
import { cookie, COUNTRY_CODE, DY_COOKIE_CATALOG, removeIndexFromArray } from '@/utils'
import AllCountriesJson from '../../../public/json/countries/ALL-countries.json'
import AllRegionsJson from '../../../public/json/countries/ALL-regions.json'

export async function getCountries() {
  return AllCountriesJson as Array<{ value: string; name: string }>
}

export async function getRegions() {
  return AllRegionsJson as Array<{ value: string; name: string }>
}


type TypeRegionItem = {
  value: string
  name: string
  hidden?: boolean
  selected?: boolean
}

export type TypeRegionJson = TypeRegionItem[]

export async function getSubdivisions(countryCode) {
  const jsonPath = `/json/countries/${countryCode}-subdivisions.json`
  const data:TypeRegionJson = await fetch(jsonPath).then(res => res.json())
  const dataArr = Array.from(data)
  const subdivisionWithData = []

  if(countryCode === 'ES') {
    const dataStores:TypeRegionJson = await fetch(`/json/countries/${countryCode}-subdivisions-with-stores.json`).then(res => res.json())
    const subdivisionsWithStores = Array.from(dataStores)

    for (const item of subdivisionsWithStores) {
      const idx = dataArr.findIndex(o => o.value === item.value)

      if (idx !== -1) {
        subdivisionWithData.push({ ...dataArr[idx], ...item })
        removeIndexFromArray(dataArr, idx)
      }
    }
  }

  return subdivisionWithData.concat(dataArr)
}


const getSubdivisionsFiltered = (subdivisions: TypeRegionJson, countryCode: string, subdivision: string, lang: string) => {
  const cookieRegion = cookie.get(DY_COOKIE_CATALOG ?? COUNTRY_CODE)
  let filtered = subdivisions

  if (countryCode === 'ES') {
    filtered = subdivisions.filter(item => !item.hidden).map(item => {
      if (item.value === subdivision) return { ...item, selected: true }
      return item
    })

    const showResto = cookieRegion === 'ES' && (lang === 'es-ES' || lang === 'es')
    filtered.push({ name: 'Resto de España', value: 'ES', selected: showResto })
  }

  return filtered
}


export const useRegions = (countryCode: string, subdivision: string, lang: string) => {
  const countries = useMemo(() => getCountries().then(res => res), [])
  const subdivisions = useMemo(() => countryCode === 'ES' ? getSubdivisions(countryCode).then(res => getSubdivisionsFiltered(res, countryCode, subdivision, lang)) : [], [countryCode, subdivision, lang])

  return { countries, subdivisions }
}
